import { memo } from 'react';
import Navbar from "../../components/NavBar/Index"
import BulkOrders from "../../components/Bulk-Orders/Index"
const Index = () => {
  return (
    <div className='flex flex-1 flex-col overflow-hidden px-2 md:px-4'>
      <div className='flex-1 flex flex-col min-h-0 mt-2 overflow-hidden'> 
        <BulkOrders />
      </div>
    </div>
  );
};

export default memo(Index);